/* eslint-disable no-prototype-builtins */
import { useEffect, useState } from "react";
import { endPoints, getData } from "../utilities/networkCalls";
import { CurrentPlan, Plan, PLANS } from "../components/Plans/plansConstants";

const usePlansHook = () => {
    const [loadingPlans, setLoadingPlans] = useState(true);
    const [allPlans, setAllPlans] = useState<Plan[] | []>([]);
    const [showTrial, setShowTrial] = useState(true);
    const [annualDiscount, setAnnualDiscount] = useState(0);
    const [currentPlan, setCurrentPlan] = useState<CurrentPlan | null>(
        // @ts-expect-error hack
        {
            plan_id: 99,
        },
    );
    const [maxDiscount, setMaxDiscount] = useState(0);
    const [currentRevenue, setCurrentRevenue] = useState(0);
    const [currentOrders, setCurrentOrders] = useState(0);
    const [usagePercent, setUsagePercent] = useState(0);
    const [isExhausted, setIsExhausted] = useState(false);
    const [nextRefreshDate, setNextRefreshDate] = useState("");
    const [slideCartLegacy, setSlideCartLegacy] = useState<0 | 1>(0);
    const isTrial = !!currentPlan?.trial_status;

    const getAllPlans = async () => {
        setLoadingPlans(true);
        const res = await getData({ url: endPoints.getAllPlans });
        if (res.status == 200) {
            const usedRevenue = res?.data?.usedRevenueThisMonth || 0;
            const usedOrders = res?.data?.totalOrderRevenue || 0;
            setAllPlans(res?.data?.allPlans || []);
            setAnnualDiscount(res?.data?.annualDiscount || 0);
            setMaxDiscount(
                Math.max(...(res?.data?.allPlans?.map((plan: { discount: number }) => plan.discount) || [0])),
            );
            setNextRefreshDate(res?.data?.plan_end_date);
            setCurrentPlan(res?.data?.currentPlan?.hasOwnProperty("type") ? res?.data?.currentPlan : null);
            setCurrentRevenue(usedRevenue);
            setSlideCartLegacy(res?.data?.slide_cart_legacy == 1 ? 1 : 0);

            setShowTrial(res?.data?.show_trial || false);
            if (res?.data?.currentPlan?.plan_id == PLANS.FREE_OLD && usedRevenue > 0) {
                setUsagePercent((usedRevenue / res?.data?.currentPlan?.revenue) * 100);
            } else {
                setUsagePercent(0);
            }
            setCurrentOrders(usedOrders || 0);
            if (
                (res?.data?.currentPlan?.plan_id == PLANS.FREE_NEW ||
                    res?.data?.currentPlan?.plan_id == PLANS.NEW_PLAN ||
                    res?.data?.currentPlan?.plan_id == PLANS.BASIC_ANNUAL ||
                    res?.data?.currentPlan?.plan_id == PLANS.STARTER_ANNUAL ||
                    res?.data?.currentPlan?.plan_id == PLANS.STARTER) &&
                usedOrders > 0
            ) {
                setUsagePercent((usedOrders / res?.data?.currentPlan?.total_orders) * 100);
            } else {
                setCurrentOrders(0);
            }
        } else {
            setAllPlans([]);
            setCurrentPlan(null);
            setCurrentRevenue(0);
            setCurrentOrders(0);
        }
        setLoadingPlans(false);
    };

    useEffect(() => {
        if (usagePercent >= 100 && currentPlan?.plan_id == PLANS.FREE_OLD) {
            setIsExhausted(true);
        } else if (
            (usagePercent >= 100 && currentPlan?.plan_id == PLANS.FREE_NEW) ||
            (usagePercent >= 100 && currentPlan?.plan_id == PLANS.NEW_PLAN) ||
            (usagePercent >= 100 && currentPlan?.plan_id == PLANS.STARTER) ||
            (usagePercent >= 100 && currentPlan?.plan_id == PLANS.BASIC_ANNUAL) ||
            (usagePercent >= 100 && currentPlan?.plan_id == PLANS.STARTER_ANNUAL)
        ) {
            setIsExhausted(true);
        } else {
            setIsExhausted(false);
        }
    }, [usagePercent, currentPlan, currentOrders]);

    return {
        loadingPlans,
        allPlans,
        currentPlan,
        currentRevenue,
        getAllPlans,
        usagePercent,
        isExhausted,
        isTrial,
        showTrial,
        setShowTrial,
        nextRefreshDate,
        maxDiscount,
        currentOrders,
        annualDiscount,
        slideCartLegacy,
    };
};

export default usePlansHook;
